var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "bubbles-a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bubbles-b",
    d: "M0 0h9.62v10H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4)",
    filter: "url(#bubbles-a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11s-.5 0-.5.5.5.5.5.5A1.5 1.5 0 0 1 7 13.5s0 .5.5.5.5-.5.5-.5A2.5 2.5 0 0 0 5.5 11M13 9.5s0 .5.5.5.5-.5.5-.5A2.5 2.5 0 0 0 11.5 7s-.5 0-.5.5.5.5.5.5A1.5 1.5 0 0 1 13 9.5",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.929a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-9a5 5 0 1 0 .001 10A5 5 0 0 0 5 8.93",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.38 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bubbles-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bubbles-b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.62 0A4.998 4.998 0 0 0 0 3.095c.33.077.651.176.957.306A3.998 3.998 0 0 1 8.62 5a4 4 0 0 1-4 4h-.004a6.083 6.083 0 0 1-.095.99c.034.001.065.01.099.01a5 5 0 0 0 0-10",
    fill: "#000",
    mask: "url(#bubbles-c)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.39667c27.svg";
export { ForwardRef as ReactComponent };